import React, { useEffect, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const SidebarItem = ({
  label,
  sidebarExpanded,
  Icon,
  isSelected,
  onClick,
  onExpand,
  onCollapse,
  onToggle,
  children,
  expanded,
  activeSubPath,
}) => {
  const [hovered, setHovered] = useState(false);
  const [canHover, setCanHover] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(hover: hover)');
    const updateHoverSupport = () => setCanHover(mediaQuery.matches);
    updateHoverSupport();
    mediaQuery.addEventListener('change', updateHoverSupport);
    return () => mediaQuery.removeEventListener('change', updateHoverSupport);
  }, []);

  const getBackgroundColor = () => {
    if (isSelected) return '#3587B8';
    if (hovered) return '#9cc8e2';
    return 'transparent';
  };

  const getTextColor = () => {
    if (isSelected ) return '#ffffff';
    return '#565656';
  };

  const handleClick = () => {
    if (children) {
      onToggle?.();
    } else {
      onClick();
    }
  };

  const handleMouseEnter = () => {
    setHovered(true);
    if (children && sidebarExpanded && canHover) {
      onExpand?.();
    }
  };

  const handleMouseLeave = () => {
    setHovered(false);
    if (children && canHover) {
      onCollapse?.();
    }
  };

  return (
    <li
      className="list-none"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        onClick={handleClick}
        style={{
          backgroundColor: getBackgroundColor(),
          color: getTextColor(),
        }}
        className={`flex items-center justify-center space-x-3 sm:justify-start mt-3 p-3 text-[16px] cursor-pointer transition-all duration-300 ease-in-out
          ${sidebarExpanded ? 'rounded-full' : 'rounded-full mx-auto'}`}
      >
        <Icon style={{ color: getTextColor(), width: '28px', height: '28px' }} />
        {sidebarExpanded && (
          <span
            style={{ color: getTextColor() }}
            className="flex justify-between items-center flex-1 whitespace-nowrap"
          >
            {label}
            {children && (
              <span className="ml-2">
                {expanded ? (
                  <KeyboardArrowUpIcon style={{ fontSize: 20, color: getTextColor() }} />
                ) : (
                  <KeyboardArrowDownIcon style={{ fontSize: 20, color: getTextColor() }} />
                )}
              </span>
            )}
          </span>
        )}
      </div>

      {children && expanded && sidebarExpanded && (
        <ul className="pl-6 pb-1">
          {children.map((child, i) => {
            const isActive = activeSubPath === child.path;
            return (
              <li
                key={i}
                onClick={() => onClick(child.path)}
                className={`flex items-center gap-2 text-[16px] pt-4 cursor-pointer transition-all duration-300 rounded-md ${isActive ? 'text-[#3587B8] font-semibold' : 'text-[#808080] hover:text-[#3587B8]'
                  }`}
              >
                <ChevronRightIcon style={{ fontSize: 18 }} />
                {child.label}
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};

export default SidebarItem;
